import type { SVGProps } from 'react';

const Network = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="8" cy="3.34395" r="0.833333" stroke="currentColor" />
    <circle cx="8" cy="8.01064" r="0.833333" stroke="currentColor" />
    <circle
      cx="12.6667"
      cy="8.01064"
      r="0.833333"
      transform="rotate(90 12.6667 8.01064)"
      stroke="currentColor"
    />
    <circle
      cx="10.6667"
      cy="10.6773"
      r="0.5"
      transform="rotate(90 10.6667 10.6773)"
      fill="currentColor"
    />
    <circle
      cx="10.6667"
      cy="5.17731"
      r="0.5"
      transform="rotate(90 10.6667 5.17731)"
      fill="currentColor"
    />
    <circle
      cx="5.16666"
      cy="10.6773"
      r="0.5"
      transform="rotate(90 5.16666 10.6773)"
      fill="currentColor"
    />
    <circle
      cx="5.16666"
      cy="5.17731"
      r="0.5"
      transform="rotate(90 5.16666 5.17731)"
      fill="currentColor"
    />
    <circle cx="8" cy="12.6773" r="0.833333" stroke="currentColor" />
    <circle
      cx="3.33333"
      cy="8.01064"
      r="0.833333"
      transform="rotate(90 3.33333 8.01064)"
      stroke="currentColor"
    />
  </svg>
);

export default Network;
